const serviveData = [
    {
        id: 1,
        image: '/assets/images/resource/letting.jpg',
        title: 'Lettings',
        desc: 'Professional marketing, viewings, and securing the right tenants.',
        detailslink: '/lettings-details',
    },
    {
        id: 3,
        image: '/assets/images/resource/management.jpg',
        title: 'Landlords',
        desc: 'Full property management, letting services, and compliance checks.',
        detailslink: '/landlords-details',
    },
    {
        id: 4,
        image: '/assets/images/resource/tenant.jpg',
        title: 'Tenants',
        desc: 'Helping you find clean, reliable homes with transparent processes.',
        detailslink: '/tenants-details',
    },
    {
        id: 5,
        image: '/assets/images/resource/refurbishments.jpg',
        title: 'Refurbishments',
        desc: 'Expert renovation and modernizing to boost property value.',
        detailslink: '/refurbishments-details',
    }
];

export default serviveData;
